import { useContext } from 'react';
import { SocketContext } from '../context';

export function useSockets() {
  const context = useContext(SocketContext);
  return { ...context };
}
